import {
  S3_BUCKET_NAME_LEADERBOARD_ASSETS,
  S3_BUCKET_NAME_PRIZE_ASSETS,
} from '@daymade/common-lib/constants';

export interface IImageResizeServiceOptions {
  width?: number | undefined;
  height?: number | undefined;
  quality?: number | undefined;
  /** A cache bust parameter */
  v?: string | undefined;
}

/** Uses the Daymade image resize to resize images. The Daymade image resize service uses a lambda. The code is located
 * here:
 *
 * https://github.com/DAYMADEUK/lambda-image-transformer
 *
 */
export function resizeImageUrl(
  imageUrl: string,
  options: IImageResizeServiceOptions,
) {
  // Replace bucket URLs with the production environment's image resize service. We don't have a need
  // for a non-prod version of the image resizer right now, as all environments use the same source
  // S3 buckets
  const resizeImagePath = imageUrl
    .replace('https://prize-assets.daymade.co.uk/', 'prize-assets/')
    .replace(
      `https://${S3_BUCKET_NAME_PRIZE_ASSETS}.s3.amazonaws.com/`,
      'prize-assets/',
    )
    .replace(`https://leaderboard-photos.daymade.co.uk/`, 'leaderboard-assets/')
    .replace(
      `https://triphunters-leaderboard-photos.s3.eu-west-1.amazonaws.com/`,
      'leaderboard-assets/',
    )
    .replace(
      `https://${S3_BUCKET_NAME_LEADERBOARD_ASSETS}.s3.amazonaws.com/`,
      'leaderboard-assets/',
    )
    .replace(`https://website-assets.daymade.co.uk/`, 'website-assets/')
    .replace(
      `https://daymade-website-assets.s3.eu-west-1.amazonaws.com/`,
      'website-assets/',
    );

  // If the image we are resizing isn't on the allow list, then don't attempt to use the image resizing service
  if (resizeImagePath.length == imageUrl.length) {
    // The image URL didn't change, don't use image resizing service
    return imageUrl;
  }

  let queryString = '';
  for (const key in options) {
    const value = options[key as keyof IImageResizeServiceOptions];
    if (value != undefined) {
      queryString += '&' + key + '=' + value;
    }
  }

  if (queryString) {
    return (
      'https://images.daymade.co.uk/' +
      resizeImagePath +
      '?' +
      queryString.substring(1)
    );
  }

  return 'https://images.daymade.co.uk/' + resizeImagePath;
}
